import { render, staticRenderFns } from "./PremiumAd.vue?vue&type=template&id=0435b162&scoped=true"
import script from "./PremiumAd.vue?vue&type=script&lang=js"
export * from "./PremiumAd.vue?vue&type=script&lang=js"
import style0 from "./PremiumAd.vue?vue&type=style&index=0&id=0435b162&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0435b162",
  null
  
)

export default component.exports